import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';
import { getInstance } from '../../../../services/instance';

export interface Pair {
  personaId: string;
  programId: string;
  disabled: boolean;
  synced: boolean;
  syncStatus: 'synced' | 'in-progress' | 'error' | 'not-started';
}

export default async function (
  flowAPI: ControllerFlowAPI,
  programId: string,
): Promise<void> {
  const instanceFromUrl = getInstance(flowAPI);
  const { withErrorHandler } = flowAPI.errorHandler;

  try {
    const getPersonaPairsTransaction =
      flowAPI.panoramaClient.transaction('get-persona-pairs');

    getPersonaPairsTransaction.start();

    const response = await withErrorHandler(
      async () => {
        return flowAPI.httpClient.get<Pair>(
          `/_api/online-programs-ai-helper-serverless/pair`,
          {
            params: {
              key: programId,
            },
            headers: {
              Authorization: instanceFromUrl,
            },
          },
        );
      },
      {
        errorCodesMap: {
          applicationError: {},
        },
      },
    );

    getPersonaPairsTransaction.finish();

    const pair = response?.data || null;

    flowAPI.controllerConfig.setProps({
      currentChatPair: pair,
    });

    if (pair && (pair.disabled || !pair.synced)) {
      console.error('Chat was not initialised properly.');
    }
  } catch (error) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(error);

    handleError({
      error,
      resolvedError,
      context: 'GetPersonaPair',
      preventErrorMonitorReport: !shouldReportErrorMonitor(error),
    });
  }
}
